import { TERMINOLOGY_TOKENS } from "@app/shared/terminology/terminology-token.catalog";
import { defineTerminologyUsage, TERMINOLOGY_CONFIGURATION_CODES, TERMINOLOGY_USAGE_KINDS } from "@app/shared/terminology/terminology-usage";

export const HEARING_DISCUSSION_TERMINOLOGY = {
  outcome: defineTerminologyUsage({
    usageId: "phms.at-hearing.discussion.prior-outcome", token: TERMINOLOGY_TOKENS.decisionOutcome,
    fallbackText: "Outcome", kind: TERMINOLOGY_USAGE_KINDS.templateText,
    configurationCode: TERMINOLOGY_CONFIGURATION_CODES.programPack,
    surface: { featureCode: "phms", surfaceCode: "hearing-discussion", componentCode: "HearingOffenseSectionComponent",
      locations: [{ kind: "route", value: "/phms/hearing-detail" }] },
  }),
} as const;
